import React from "react"
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"

const NonAuthMiddleware = (props) => {
  const { user, auth } = useSelector((state) => state.user)
  if (auth) {
    return (
      <Navigate
        to={{ pathname: "/dashboard", state: { from: props.location } }}
      />
    )
  }
  return <React.Fragment>{props.children}</React.Fragment>
}

export default NonAuthMiddleware
